import InputGroup from "./InputGroup";
import CoinIcon from "../../assets/images/icon.coin.svg";
import CloudIcon from "../../assets/images/icon.cloud.svg";
import CheckIcon from "../../assets/images/icon.check.black.svg";


const EnterpriseTierForm = () => {
    return (
        <InputGroup label={
            <>
                <div className="flex-align-center gap-2">
                    <div className="text-[32px] font-bold">Enterprise</div>
                    <div className="text-[24px] text-primary font-semibold">₩200,000원 / 월</div>
                </div>
                <div className="text-quaternary font-medium">
                    대량의 제품을 취급하고 본격적으로 AI 메시지 Agent를 도입하고자 하는 회사에게  적합합니다.
                </div>
            </>
        }>
            <div className="flex gap-[7px]">
                <div className="flex-col gap-2 bg-bluedepth rounded-[8px] px-[20px] py-[16px]">
                    <div className="text-[20px] font-bold">혜택</div>
                    <div className="flex-align-center gap-2">
                        <img src={CoinIcon} alt="coin" width="24" height="24" />
                        <div>가입 기념 5,000 크레딧 무료 제공 (2달내 사용)</div>
                    </div>
                    <div className="border-[1px]" style={{borderColor: "rgba(30, 14, 98, 0.08)"}}></div>
                    <div className="flex-align-center gap-2">
                        <img src={CloudIcon} alt="cloud" width="24" height="24" />
                        <div>무제한 제품 등록</div>
                    </div>
                </div>
                <div className="flex-1 flex-col gap-2 bg-shape rounded-[8px] px-[20px] py-[16px]">
                    <div className="text-[20px] font-bold">주요 기능</div>
                    <div>
                        <div className="flex-align-center gap-1">
                            <img src={CheckIcon} alt="check" width="14" height="14" />
                            <div>Pro 플랜의 모든 기능 +</div>
                        </div>
                        <div className="flex-align-center gap-1">
                            <img src={CheckIcon} alt="check" width="14" height="14" />
                            <div>API 서포트</div>
                        </div>
                        <div className="flex-align-center gap-1">
                            <img src={CheckIcon} alt="check" width="14" height="14" />
                            <div>전담 고객 매니저</div>
                        </div>
                        <div className="flex-align-center gap-1">
                            <img src={CheckIcon} alt="check" width="14" height="14" />
                            <div>신규 기능 선 체험</div>
                        </div>
                    </div>
                </div>
            </div>
        </InputGroup>
    )
}

export default EnterpriseTierForm;